// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3onaz","emails":"CreateEditClinics_emails__3194q","emailTagLabel":"CreateEditClinics_emailTagLabel__ZBGbE"};